"use client";

import { Suspense } from "react";
import { usePathname } from "next/navigation";
import { useConvexAuth, useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { normalizeAccountType } from "@/lib/auth/types";
import { isRouteActive } from "@/lib/navigation/active-state";
import { DashboardMobileNav } from "@/app/(protected)/dashboard/components/dashboard-mobile-nav";
import { resolveDashboardAudience } from "@/app/(protected)/dashboard/components/navigation/account-type-policy";

function isBrowsePath(pathname: string): boolean {
  return (
    isRouteActive(pathname, "/listing", { exact: true }) ||
    isRouteActive(pathname, "/listing/search") ||
    isRouteActive(pathname, "/listing/category")
  );
}

function CompanyTabBar() {
  const { isAuthenticated } = useConvexAuth();
  const current = useQuery(
    api.companies.queries.getCurrentUserWithCompany,
    isAuthenticated ? {} : "skip",
  );
  const company = current?.company;
  if (!company) return null;
  const audience = resolveDashboardAudience(
    company.accountTypes,
    normalizeAccountType(company.accountType),
    company.statedUses,
  );
  return (
    <>
      <div
        aria-hidden="true"
        className="h-[calc(3rem+env(safe-area-inset-bottom))] md:hidden"
      />
      <div data-phone-tab-bar="" className="fixed inset-x-0 bottom-0 z-40 md:hidden">
        <DashboardMobileNav companyId={company._id} audience={audience} />
      </div>
    </>
  );
}

export function SignedInPhoneTabBar() {
  const pathname = usePathname();
  if (!isBrowsePath(pathname)) return null;
  return (
    <Suspense fallback={null}>
      <CompanyTabBar />
    </Suspense>
  );
}
